import {
    vkMusicBundleImagesPreload,
    vkMusicBundleOfferMaxShowCount,
    vkMusicBundleOfferShowDaysInterval,
    vkMusicBundlePromoEnabled,
} from 'reactApp/appHelpers/featuresHelpers/features/vkMusicBundle';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { VK_MUSIC_BUNDLE_SOURCE, vkMusicBundleLogger } from 'reactApp/modules/vkMusic/vkMusic.const';
import { openVkMusicBundleModal } from 'reactApp/modules/vkMusic/vkMusic.helpers';
import { VkMusicBundleActions } from 'reactApp/modules/vkMusic/vkMusic.module';
import { VkMusicBundleSelectors } from 'reactApp/modules/vkMusic/vkMusic.selectors';
import { store as reduxStore } from 'reactApp/store';
import { preloadVkMusicBundleModalCover } from 'reactApp/ui/VkMusic/VkMusicBundleModal/VkMusicBundleModal.helpers';
import { preloadAvatars } from 'reactApp/ui/VkMusic/VkMusicConfirmModal/VkMusicConfirmModal.helpers';
import { put, take } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';

const VK_MUSIC_BUNDLE_ID = 'vkmusic-bundle-id';

export function* initVkMusicBundleModal() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const showCount: number = storeHelper.getValue(VK_MUSIC_BUNDLE_ID) || 0;
    const periodPassed = !showCount || storeHelper.isPassed(VK_MUSIC_BUNDLE_ID, { daysCount: vkMusicBundleOfferShowDaysInterval });

    // специфичные для промо условия
    const conditions = {
        isNotHome: !isHome,
        isPromoFlagDisabled: !vkMusicBundlePromoEnabled,
        maxShowCount: showCount >= vkMusicBundleOfferMaxShowCount,
        periodNotPassed: !periodPassed,
    };

    if (Object.values(conditions).includes(true)) {
        vkMusicBundleLogger.info(`promo init failure`, conditions);
        return;
    }

    const { isLoaded, isLoading } = yield* select(VkMusicBundleSelectors.getBundleInfo);
    if (!isLoaded && !isLoading) {
        yield put(VkMusicBundleActions.loadVkMusicBundleInfo());
    }
    yield take(VkMusicBundleActions.getVkMusicBundleInfoSuccess);

    // canOffer учитывает общие для всех точек входа условия
    const { canOffer, vkid, tariffInfo } = yield* select(VkMusicBundleSelectors.getBundleInfo);

    if (!canOffer || !tariffInfo) {
        vkMusicBundleLogger.info('promo init failure', conditions);
        return;
    }

    vkMusicBundleLogger.info('promo init success', conditions);

    yield put(
        addPromoToShowQueue({
            type: EPromoType.vkMusicBundle,
            promoId: VK_MUSIC_BUNDLE_ID,
            onShow: () => {
                storeHelper.markAsShown(VK_MUSIC_BUNDLE_ID, showCount + 1);
                reduxStore.dispatch(promoShown(EPromoType.vkMusicBundle));
            },
            onClick: () => {
                reduxStore.dispatch(removePromo(EPromoType.vkMusicBundle));
            },
            onClose: () => {
                reduxStore.dispatch(removePromo(EPromoType.vkMusicBundle));
            },
            tariffInfo,
            vkid,
        })
    );
}

export function* showVkMusicBundleModal() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.vkMusicBundle));

    if (!promo) {
        vkMusicBundleLogger.error('show enter modal: no promo');
        return;
    }

    vkMusicBundleLogger.info('show enter modal');

    const { onShow, onClick, onClose, tariffInfo, vkid } = promo;

    if (vkid && vkMusicBundleImagesPreload.avatars) {
        yield preloadAvatars(vkid);
    }

    if (vkMusicBundleImagesPreload.cover) {
        yield preloadVkMusicBundleModalCover();
    }

    yield call(openVkMusicBundleModal, { onShow, onClick, onClose, tariffInfo, vkid, source: VK_MUSIC_BUNDLE_SOURCE.HOME_PROMO_OFFER });
}
